/**
 * Utility functions for the application
 */

/**
 * Merges class names together, filtering out falsy values
 *
 * @param classes - Class names to merge
 * @returns Merged class string
 *
 * @example
 * ```ts
 * cn('btn', 'btn-primary', isDisabled && 'opacity-50')
 * // => 'btn btn-primary opacity-50'
 * ```
 */
export function cn(...classes: (string | boolean | undefined | null)[]): string {
  return classes.filter(Boolean).join(' ');
}
